import { Mail, MessageSquare, Phone } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { useI18n } from "../i18n/I18nContext";
import { BRAND } from "../lib/brand";

export default function ContactPage() {
  const { lang } = useI18n();
  return (
    <div className="min-h-screen bg-white text-charcoal" data-testid="contact-page">
      <SiteHeader variant="light" />
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <p className="text-[11px] uppercase tracking-[0.32em] text-emerald2 font-semibold mb-5">{lang === "en" ? "Contact" : "Liên hệ"}</p>
        <h1 className="font-serif text-5xl md:text-6xl text-charcoal">{lang === "en" ? "Get in touch" : "Liên Hệ"}</h1>
        <p className="mt-4 text-warmgray-700">{lang === "en"
          ? "Sponsorship, partnerships, press, or questions — we'd love to hear from you."
          : "Tài trợ, hợp tác, truyền thông, hoặc câu hỏi — chúng tôi rất mong được lắng nghe từ bạn."}</p>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          <a href={`tel:${BRAND.phone}`} className="bg-warmgray-50 border border-warmgray-200 rounded-3xl p-6 hover:-translate-y-0.5 hover:border-gold-500/60 transition-all" data-testid="contact-phone">
            <div className="w-12 h-12 rounded-2xl bg-charcoal text-gold-300 flex items-center justify-center"><Phone className="w-5 h-5" /></div>
            <div className="mt-4 text-[10px] uppercase tracking-[0.22em] text-warmgray-500 font-semibold">{lang === "en" ? "AI Voice · Toll-free 24/7" : "Cố Vấn AI · Miễn phí 24/7"}</div>
            <div className="mt-1 font-mono text-lg text-charcoal">{BRAND.phoneDisplay}</div>
          </a>
          <a href={`mailto:${BRAND.email}`} className="bg-warmgray-50 border border-warmgray-200 rounded-3xl p-6 hover:-translate-y-0.5 hover:border-emerald2/40 transition-all" data-testid="contact-email">
            <div className="w-12 h-12 rounded-2xl bg-emerald2 text-white flex items-center justify-center"><Mail className="w-5 h-5" /></div>
            <div className="mt-4 text-[10px] uppercase tracking-[0.22em] text-warmgray-500 font-semibold">Email</div>
            <div className="mt-1 font-medium text-charcoal">{BRAND.email}</div>
          </a>
          <div className="bg-warmgray-50 border border-warmgray-200 rounded-3xl p-6 sm:col-span-2">
            <div className="w-12 h-12 rounded-2xl bg-gold-500 text-charcoal flex items-center justify-center"><MessageSquare className="w-5 h-5" /></div>
            <div className="mt-4 text-[10px] uppercase tracking-[0.22em] text-warmgray-500 font-semibold">{lang === "en" ? "AI Advisor (chat)" : "Cố Vấn AI (trò chuyện)"}</div>
            <div className="mt-1 font-medium text-charcoal">{lang === "en" ? "Open the AI Advisor — available 24/7" : "Mở Cố vấn AI — 24/7"}</div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
